import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Language from "../components/common/Language";
import Currency from "../components/common/Currency";
import style from "./commonstyle.module.scss";
import { connect } from "react-redux";
import Logo from "../../assets/images/logos/logo-dark.png";
import MarkunreadOutlinedIcon from "@mui/icons-material/MarkunreadOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Link, useHistory, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import AppInfoservice from "../../service/common/Appinfo";
import profilePic from "../../assets/images/nophoto/no_photo.jpg";
import moment from "moment";

function mapStateToProps(state) {
  const { Mail } = state;
  const { Notification } = state;
  const { Menu } = state;

  return { Mail: Mail, Notification: Notification, Menu: Menu };
}

const MainNavbar = (props) => {
  console.log("props in main nav bar", props.Notification.parentOrNot);
  let pathto;

  const [state, setState] = useState({
    icononly: false,
    logoutUrl: "",
  });
  const [logo, setLogo] = useState();
  const [hideSignUp, setHideSignUp] = useState(false);
  const history = useHistory();

  function toggleIcononly() {
    document.body.classList.toggle("sidebar-icon-only");
    setState({ icononly: !state.icononly });
  }

  useEffect(() => {
    document.querySelector("#dropdown-basic").classList.remove("btn");
    document.querySelector("#dropdown-basic").classList.remove("btn-primary");
    const app = new AppInfoservice();
    app.Appinfo().then((res) => {
      if (res.status) {
        setLogo(res.data.company_info.logo);
      }
    });
  }, []);

  useEffect(() => {
    const service = new AppInfoservice();
    service.get_layout().then((res) => {
      if (res) {
        console.log("🚀00000", res.data);
        if (res.data.logout_status === "false") {
          setHideSignUp(true);
        }
      }
      setState((prev) => ({
        ...prev,
        logoutUrl: res.data.logout_url,
      }));
    });
  }, []);

  const viewmail = (evt) => {
    evt.preventDefault();
    props.history.push("/mailbox#inbox");
  };

  //notification
  const notificationContent = (item) => {
    console.log("🚀12345679", item);
    if (item.type === "material_added") {
      return <span>{t("Common.you_have")} new Document</span>;
    } else if (item.type === "news_added") {
      return <span>{t("Common.you_have")} new News</span>;
    } else if (item.type === "ticket_reply") {
      // return <span>{ticket}</span>;
      return <span>{t("Common.ticket_reply")}</span>;
    } else if (item.type === "epin_allotted") {
      return (
        <div style={{ display: "flex", gap: "5px", marginLeft: "15px" }}>
          <span
            style={{
              fontWeight: "bold",
              backgroundColor: "#d0d0e5",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              textAlign: "center",
            }}
          >
            {item.count}
          </span>{" "}
          {t("Common.epin_request_confirmed")} of ${item.amount}
        </div>
      );
    } else if (item.type == "rank_added") {
      return <span>{t("Common.rank_advance")}</span>;
    } else if (item.title === "retail_profit_bonus") {
      return <span>{t("Common.retail_profit_bonus")}</span>;
    } else if (item.title === "gsr_level_commission") {
      return <span>{t("Common.gsr_level_commission")}</span>;
    } else if (item.title === "lifestyle_point") {
      return <span>{t("Common.lifestyle_point")}</span>;
    } else if (item.title === "leg") {
      return <span>{t("Common.tsc")}</span>;
    } else if (item.title === "refferal") {
      return <span>{t("Common.leg")}</span>;
    } else if (item.title === "refferal ") {
      return <span>{t("Common.leg")}</span>;
    } else if (item.title === "referral") {
      return <span>{t("Common.leg")}</span>;
    } else if (item.title === "rank") {
      return <span>{t("Common.rank_advance")}</span>;
    } else if (item.title === "bank_account_approved") {
      return <span>{t("Common.bank_account_approved")}</span>;
    } else if (item.title === "announcement_added_title") {
      return <span>{t("Common.you_have")} new Announcement</span>;
    } else {
      return (
        <span>
          <span>{item.title}</span>
        </span>
      );
    }
  };

  const viewNotification = (items, item) => {
    pathto =
      item.type === "material_added"
        ? "/downloadDocument"
        : item.type === "epin_allotted"
        ? "/epin"
        : item.type === "news_added"
        ? "/news"
        : item.type === "announcement_added"
        ? "/news"
        : item.type === "ticket_reply"
        ? "/support"
        : "/dashboard";
    props.history.push(pathto);
    props.notificationClick(item.id);
  };

  const { Mail, t } = props;
  const { Notification } = props;
  const { Menu } = props;

  const urlData = Menu.Menu.find((element) => element.title === "register");
  const { currentTheme } = useSelector((state) => state.Theme);

  const LOgoutHandler = () => {
    history.push("/user-logout");
  };

  return (
    <div className={style.main_contant_sec}>
      <div className={style.topbar_section}>
        <div className={style.logo_sec}>
          <div
            className={`${
              currentTheme == "theme-dark"
                ? `${style.dark_mode_menubartogglebtn}`
                : `${style.menubartogglebtn}`
            }`}
            onClick={() => {
              toggleIcononly();
            }}
          >
            <span></span>
          </div>
          <a href={"dashboard"}>
            <div className={style.logo_cn}>
              <img
                src={logo ? logo : Logo}
                alt=""
                style={{ width: "120px" }}
              ></img>
            </div>
          </a>
        </div>
        <div
          className={style.top_notification_sec}
          style={{
            width: "100px",
            float: "left",
            display: "flex",
            height: "51px",
          }}
        >
          <Dropdown style={{ marginTop: "-10px" }}>
            <Dropdown.Toggle variant="Secondary">
              <Currency />
            </Dropdown.Toggle>
          </Dropdown>

          <Dropdown>
            <Dropdown.Toggle variant="Secondary">
              <Language ismainlayout={true} />
            </Dropdown.Toggle>
          </Dropdown>
        </div>
        <div className={style.top_notification_user_sec}>
          <div className={style.top_notification_sec}>
            <Dropdown
              className={`${style.top_notification_ico} ${style.tp_msg_btn} ${style.materialiconsoutlined}`}
            >
              <Dropdown.Toggle variant="Secondary">
                <MarkunreadOutlinedIcon style={{ color: "white" }} />
                {Mail.count > 0 && (
                  <span className={style.notification_count}>{Mail.count}</span>
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu className={style.notification_msg_box}>
                {Mail.count > 0 ? (
                  <div className={style.mailDropDown}>
                    <Dropdown.Item
                      className={style.notification_msg_box_cnt_row}
                      href="!#"
                      onClick={(evt) => evt.preventDefault()}
                    >
                      <p
                        className={
                          currentTheme == "theme-dark"
                            ? "mb-0 font-weight-medium float-left text-white"
                            : "mb-0 font-weight-medium float-left"
                        }
                      >
                        {t("Common.youHaveNewMail", { count: Mail.count })}{" "}
                      </p>
                      <Link
                        to="/mailbox"
                        className={`badge badge-pill badge-primary float-right ${style.viewBadge}`}
                      >
                        {t("Common.viewAll")}
                      </Link>
                    </Dropdown.Item>
                    <div className="notification_msg_box_cnt">
                      {Mail.mail_data.map((item, index) => [
                        <Dropdown.Item
                          className={style.notification_msg_box_cnt_row}
                          href="!#"
                          onClick={viewmail}
                          key={index}
                        >
                          <div className="preview-item-content">
                            <span className={`${style.image} mr-2`}>
                              <img
                                src={item.image ? item.image : profilePic}
                                alt=""
                              />
                            </span>

                            <span className="msg_box_cnt_t">
                              {item.username}
                              <br />
                              {item.mailadsubject}
                              <br />
                              <small>{item.mailadiddate}</small>
                            </span>
                          </div>
                        </Dropdown.Item>,
                      ])}
                    </div>
                  </div>
                ) : (
                  <Dropdown.Item
                    className={style.notification_msg_box_cnt_row}
                    href="!#"
                    onClick={(evt) => evt.preventDefault()}
                  >
                    <strong>{t("Common.youHaveNoNewmailNotification")}</strong>
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown
              className={`${style.top_notification_ico} ${style.tp_not_btn} ${style.materialiconsoutlined}`}
            >
              <Dropdown.Toggle variant="Secondary">
                <span>
                  <NotificationsOutlinedIcon style={{ color: "white" }} />
                </span>
                {Notification.count > 0 && (
                  <div className={style.notification_count}>
                    {Notification.count}
                  </div>
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu className={style.notification_msg_box}>
                {Notification.count > 0 ? (
                  <div className={style.mailDropDown}>
                    <Dropdown.Item
                      className={style.notification_msg_box_cnt_row}
                      href="!#"
                      onClick={(evt) => evt.preventDefault()}
                    >
                      <p
                        className={
                          currentTheme == "theme-dark"
                            ? "mb-0 font-weight-medium float-left text-white"
                            : "mb-0 font-weight-medium float-left"
                        }
                      >
                        {Notification.count + " "}
                        {t("Common.MissedNotification")}{" "}
                      </p>
                      <p
                        className={
                          currentTheme == "theme-dark"
                            ? "mb-0 font-weight-medium float-left text-white"
                            : "mb-0 font-weight-medium float-left"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          props.markAllNotification();
                        }}
                      >
                        Mark All as Read
                      </p>
                    </Dropdown.Item>
                    <div className="notification_msg_box_cnt">
                      {Notification.notification_data.map((item, index) => [
                        <Dropdown.Item
                          className={style.notification_msg_box_cnt_row}
                          onClick={(items) => {
                            viewNotification(items, item);
                          }}
                          key={index}
                        >
                          <div
                            className="preview-item-content"
                            style={{ display: "flex" }}
                          >
                            <span className={`${style.image} mr-1`}></span>
                          </div>
                          {notificationContent(item)}
                          <div style={{ margin: "2px", textAlign: "end" }}>
                            {moment
                              .utc(item.date)
                              .subtract(8, "hours")
                              .tz("Asia/Manila")
                              .format("MM/DD/YYYY h:mm:ss A")}
                            {/* {item.date} */}
                          </div>
                          <hr
                            style={{
                              marginTop: "0px",
                              marginBottom: "0px",
                            }}
                          />
                        </Dropdown.Item>,
                      ])}
                    </div>
                  </div>
                ) : (
                  <Dropdown.Item
                    className={style.notification_msg_box_cnt_row}
                    href="!#"
                    onClick={(evt) => evt.preventDefault()}
                  >
                    <strong>{t("Common.youHaveNoNewNotification")}</strong>
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className={style.top_user_acc_sec}>
            <Dropdown className={` ${style.dropdowntoggle1}`}>
              <Dropdown.Toggle
                style={{
                  color: "white",
                  fontWeight: "9000",
                  marginRight: "90px",
                }}
                variant="Secondary"
                id="dropdown-basic"
              >
                <span>
                  <img
                    className="img-xs rounded-circle"
                    src={props.image ? props.image : profilePic}
                    alt="Profile"
                  />
                </span>{" "}
                {props.userName.toUpperCase()}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{ marginTop: "-10px" }}
                className={style.dropdownmenu}
              >
                <Dropdown.Item
                  as={Link}
                  to="/profile"
                  className={style.dropdownitem}
                >
                  {t("Common.profile")}
                </Dropdown.Item>
                {!hideSignUp &&
                  props?.Notification?.parentOrNot == null &&
                  props?.Notification?.show && (
                    <Dropdown.Item
                      as={Link}
                      to={{
                        pathname:
                          urlData && urlData.url ? urlData.url : "/viewaccount",
                      }}
                      className={style.dropdownitem}
                    >
                      {t("Common.viewAccount")}
                    </Dropdown.Item>
                  )}
                {
                  <Dropdown.Item
                    as={Link}
                    onClick={LOgoutHandler}
                    className={style.dropdownitem}
                  >
                    {t("Sidemenu.logout")}
                  </Dropdown.Item>
                }
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(
  connect(mapStateToProps)(withRouter(MainNavbar))
);
